import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Circle} from 'rc-progress';
import folderImg from './../assets/images/folder.svg';

import "../assets/stylesheets/Buttons.scss";

export default class Buttons extends Component {
    
    static propTypes = {
        hasAllButtons : PropTypes.bool,
        name : PropTypes.string,
        url : PropTypes.string,
        id : PropTypes.string,
        type : PropTypes.string,
        isDownloaded : PropTypes.bool,
        downloadProgress : PropTypes.number,
        hasError : PropTypes.bool,
        onClickDelete : PropTypes.func,
        onClickDownload : PropTypes.func,
        onClickPlay : PropTypes.func,
        onClickFolder : PropTypes.func,
    }

    static defaultProps = {
        type : 'file',
    }

    handleDeleteFile(name, url, id, canDelete, e){
        this.props.onClickDelete(name, url, id, canDelete ,e);
    }

    handleDownloadFile(name, url, id, canDownload, e){
        this.props.onClickDownload(name, url, id, canDownload, e);
    }

    handleOpenBook(name, e){
        this.props.onClickPlay(name,e);
    }

    handleClickFolder(url, name, clear, e){
        this.props.onClickFolder(url, name, clear, e);
    }
    
    renderAll(){
        return this.props.type === 'folder' ? this.renderFolder() :
        (
            <div className="Buttons">
                <div className="buttons">
                    <div className={"btn-ic btn-trash" + (this.props.isDownloaded ? " active" : "")}
                         onClick={(this.props.isDownloaded ?
                             this.handleDeleteFile.bind(this, this.props.name, this.props.url, this.props.id, true) :
                             this.handleDeleteFile.bind(this, this.props.name, this.props.url, this.props.id, false))}/>
                    <div className={"btn-ic btn-download" + (this.props.isDownloaded ? " active"
                        : (this.props.hasError ? " has-error" : ""))}
                         onClick={(this.props.isDownloaded && !this.props.downloadProgress ?
                             this.handleDownloadFile.bind(this, this.props.name, this.props.url, this.props.id, false) :
                             this.handleDownloadFile.bind(this, this.props.name, this.props.url, this.props.id, true))}/>
                    <Circle
                        percent={this.props.downloadProgress}
                        strokeWidth="10"
                        trailColor="#FFFFFF"
                        strokeColor="#951F31"
                        className="btn-ic btn-circle"
                    />
                    <div className={"btn-ic btn-play" + (this.props.isDownloaded ? " active" : "")}
                         onClick={ this.handleOpenBook.bind(this, this.props.name) }/>
                </div>
            </div>
        );
        
    }
    
    renderJustDownload(){

        return this.props.type === 'folder' ? this.renderFolder() :
        (
            <div className="Buttons">
                <div className="buttons">
                    <div className={"btn-ic btn-download" + (this.props.isDownloaded ? " active"
                        : (this.props.hasError ? " has-error" : ""))}
                                onClick={(this.props.isDownloaded ?
                                    this.handleDownloadFile.bind(this, this.props.name, this.props.url, this.props.id, false) :
                                    this.handleDownloadFile.bind(this, this.props.name, this.props.url, this.props.id, true))}/>
                </div>
            </div>
        );
    }

    renderFolder(){
        const folder = <img role="presentation" className="folder" src={folderImg}/>
        return (
            <div className="Buttons">
                <div key={this.props.id}
                    className="title"
                    onClick={this.handleClickFolder.bind(this, this.props.url , this.props.name, false)}>
                    {folder}
                </div>
            </div>
        );
    }
    
    
    render(){
        return this.props.hasAllButtons ? this.renderAll() : this.renderJustDownload();
    }
}



// WEBPACK FOOTER //
// ./src/components/Buttons.js